import { Component, computed, input, output } from '@angular/core'

import { FilterParams } from '../shared/utilities/http-params'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'app-idr-filter-actions',
  imports: [MatIconModule],
  template: `
    @if (removeEnabled()) {  
      <mat-icon
        title='Remove filter condition'
        fontIcon="remove_circle_outline"
        (click)="remove.emit(row())"
      />
    }
  `,
  styles: `
    :host {
      .mat-icon {
        margin-top: 6px;
        margin-left: 6px;
        color: #777777;
        cursor: pointer;
        
        &:hover {
          color: var(--active-blue);
        }
      }
    }
  `,
})
export class IdrFilterActions {
  readonly row = input.required<FilterParams>()

  readonly remove = output<FilterParams>()

  protected removeEnabled = computed((): boolean => {
    const name = this.row().name
    return Boolean(name) && name !== 'operating_date'
  })
}
